import styled from 'styled-components';
import wixService from '../../../../../../services/wixService';

function getColorWithoutOpacity(color) {
  try {
    if (typeof color !== 'undefined' && color !== '') {
      return wixService.getTinycolor(color).setAlpha(100).toRgbString();
    }
  } catch (e) {
    console.log('e:', color);
    return color;
  }
}

export const DeepLinkBlock = styled.div.attrs(() => ({}))`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  overflow-y: auto;
  background-color: ${(props) =>
    getColorWithoutOpacity(
      wixService.getColorByreference(props.design.widget.color.value),
    )};
  background-color: ${(props) =>
    getColorWithoutOpacity(
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.widget.color.name,
      ),
    )};
  .inSide {
    padding: 30px 40px;
    .title {
      width: calc(100% - 35px);
      vertical-align: bottom;
      display: flex;
      align-items: flex-end;
      text-align: center;
      margin-bottom: 32px;
      color: ${(props) =>
        wixService.getColorByreference(props.design.headerText.color.value)};
      color: ${(props) =>
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.headerText.color.name,
        )};
      ${(props) =>
        wixService.getStyleFontByReference(props.design.headerText.font.value)};
      font: ${(props) =>
        wixService.getFontValueByComponentName(
          props.styleParams,
          props.design.headerText.font.name,
        )};
      text-decoration: ${(props) =>
        wixService.getFontTextDecoration(
          props.styleParams,
          props.design.headerText.font.name,
        )} !important;
      .clamp-lines {
        width: 100%;
      }
    }
  }
`;
export const ComponentHeader = styled.div.attrs(() => ({}))`
  height: 20px !important;
  overflow: hidden;
  margin-bottom: 18px;
  .btn-container {
    height: 24px !important;
    width: 100%;
    color: ${(props) =>
      wixService.getColorByreference(props.design.headerText.color.value)};
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.headerText.color.name,
      )};
    ${(props) =>
      wixService.getStyleFontByReference(props.design.headerText.font.value)};
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.headerText.font.name,
      )};
    text-decoration:  ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.design.headerText.font.name,
      )} !important;
    font-size: 16px !important;

    svg path {
      fill: ${(props) =>
        wixService.getColorByreference(props.design.questionText.color.value)};
      fill: ${(props) =>
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        )};
      fill-rule: evenodd;
      stroke:none;
    }
    }
  }
`;
